import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../mock";

const Services = () => {
  return (
    <section id="services" className="py-20 lg:py-28 bg-[var(--soft)]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm font-bold uppercase tracking-wider text-[var(--brand)]">
            What We Do
          </span>
          <h2 className="mt-3 font-heading text-4xl lg:text-5xl font-extrabold tracking-tight text-[var(--ink)]">
            End-to-end sourcing services
          </h2>
          <p className="mt-4 text-lg text-[var(--muted-ink)]">
            From finding the right manufacturer to delivering goods at your door — we handle every step of your India sourcing journey.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service) => {
            const Icon = service.icon;
            return (
              <div
                key={service.title}
                className="group relative overflow-hidden rounded-2xl bg-white p-7 shadow-[0_4px_20px_rgba(17,17,26,0.05)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_18px_40px_rgba(108,92,231,0.15)]"
              >
                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-[var(--brand)]/5 transition-transform duration-500 group-hover:scale-150" />
                <span className="relative flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--brand)]/10 text-[var(--brand)] transition-colors duration-300 group-hover:bg-[var(--brand)] group-hover:text-white">
                  <Icon size={26} />
                </span>
                <h3 className="relative mt-6 font-heading text-xl font-bold text-[var(--ink)]">
                  {service.title}
                </h3>
                <p className="relative mt-3 text-[15px] leading-relaxed text-[var(--muted-ink)]">
                  {service.description}
                </p>
                <span className="relative mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[var(--brand)] opacity-0 transition-all duration-300 group-hover:opacity-100">
                  Learn more <ArrowUpRight size={16} />
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
